import axios from "axios";

const baseDomain = process.env.VUE_APP_API_URL;
const baseURL = `${baseDomain}/api/v2`; // Incase of /api/v1;

axios.defaults.baseURL = baseURL;

let config = {
	headers: {'Access-Control-Allow-Origin': '*'}
};

// ALL DEFAULT CONFIGURATION HERE
// export default axios.create({baseURL});

let instance = axios.create(config);

export default instance;
